export const storeModule = {
  address: "가게주소",
  baseInfo: "기본정보",
  content: "내용",
  time: "영업시간",
  dateTime: "영업일",
  pickTime: "직접 찾기 시간",
  devTime: "배달 시간",
  payFun: "지불수단",
  detail: "매점 상세",
  detailInfo: "점포 상세함",
  devPrice: "배송비",
  minPrice: "최저 배달비",
  freePrice: "*이상 배송비 무료",
  freeDevPriceDiff: "아직 * 배송비 무료",
  freeDevPrice: "배송비 무료",
  leal: "특별 상법",
  lealTab1: "항목",
  lealTab2: "계산란",
  lealTitle1: "상가명(회사명, 상호, 상점명)",
  lealTitle2: "상가 주소",
  lealTitle3: "대표자 또는 경영 책임자",
  lealTitle4: "대표자 또는 경영책임자(가칭)",
  lealTitle5: "연락처/홈페이지",
  lealTitle6: "연락처/이메일",
  lealTitle7: "연락처/전화",
  lealTitle8: "상품가격구간",
  lealTitle9: "납품 기일, 발송방식",
  lealTitle10: "지급시간과 지급방식",
  lealTitle11: "상품가격을 제외한 필수비용/배송비, 수수료, 소비세 등",
  lealTitle12:
    "반품조건/반품기한,반품에 따른 배송비 또는 중도해지, 탈퇴의 조건",
  lealTitle13: "하자품의 처리 방법",
  shopTimeOuter1: "수리 중단",
  shopTimeOuter2: "수령에 동의하지 않습니다.",
  shopTimeOuterSm1: "정지 중",
  shopTimeOuterSm2: "시간 외",
  orderSm1: "예약 가능",
  orderDayBefore: "*일 전에",
  noText: "없음",
  storeRemark: "점포 설명",
  devDistanceNo: "현재 배송지는 점포 배송 범위 내에 있지 않습니다.다른 점포를 선택해 주세요",
  devSearch: "검색",
  devNoAddress: "아래 중 임의의 방법으로 배송 주소를 설정해 주세요"
};
export const evaluationModule = {
  star: "만족도",
  contentHolder: "평가 글 남겨 주세요",
  noStar: "만족도를 선택하십시오",
  noContent: "평가 내용을 입력하십시오",
  submitSuccess: "평가 성공",
  replay: "가게 댓글",
  uploadSuccess: "업로드 성공"
};
